import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useMembership } from '@/hooks/useMembership';
import { useIsPhone } from '@/hooks/useIsPhone';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';

export const Route = createFileRoute('/_app/')({
  component: LandingRedirect,
});

/** Technicians on a phone start at Today (/entry); everyone else at the farm overview. */
function LandingRedirect() {
  const { role, isLoading } = useMembership();
  const isPhone = useIsPhone();
  if (isLoading) {
    return (
      <div className="flex justify-center py-20">
        <LoadingSpinner />
      </div>
    );
  }
  return <Navigate to={role === 'technician' && isPhone ? '/entry' : '/overview'} replace />;
}
